enum PassTypeEnum {
  SkiPass = 'Ski Pass',
  PedestrianPass = 'Pedestrian Pass'
}

export {
  PassTypeEnum,
}
